import { apiClientV2 } from '@/services/rest-api/apiClient'

export async function getAssetURL(assetType, module) {
  const params = {
    module: module,
    type: assetType,
  }

  const baseURL = process.env.VUE_APP_API_VSMS_REST_URL + '/assets/value'

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    params: params,
  })

  const result = {
    assetType: assetType,
    module: module,
    value: response?.data,
  }
  return result
}
